import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getRegistry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { getEventQueue } from '../../../shared/utils/eventQueue';
import { IApplicationState } from '../../../shared/types/redux';
import { TThunkDispatch } from '../../../shared/types/redux/thunk';
import { isCompareFlightTooltipShow } from '../../../shared/utils/isCompareFlightTooltipShow';
import { createReduxStore } from '../../../shared/utils/redux';
import { getFlatTourBookingSchedule } from '../flatTourBooking';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const microfrontendsRegistry = getRegistry();
  const microfrontendsAPI = createMicrofrontendsAPI();
  const telemetry = getTelemetry();

  const serverInitialState = config.getStrict<IApplicationState>('initialState');
  const initialState: IApplicationState = {
    ...serverInitialState,
    compareFlightTooltip: {
      isCompareFlightTooltipShow: isCompareFlightTooltipShow(window.location.search),
      isCompareFlightModalOpen: false,
    },
  };

  const reduxContext = {
    config,
    httpApi,
    logger,
    microfrontendsRegistry,
    microfrontendsAPI,
    telemetry,
    eventQueue: getEventQueue(),
  };

  const store = createReduxStore(initialState, reduxContext, true);
  (store.dispatch as TThunkDispatch)(getFlatTourBookingSchedule());

  return store;
}
